const styles = (theme) => ({

	title: {
		fontSize: '22px',
		color: '#47525E',
		marginRight: 16,
		marginLeft: 16,
	},

	titleAndSearch: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
	},

	searchPP: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingBottom: theme.spacing(1),
	},

	searchBar: {
		width: '200px',
		display: 'inline-flex',
		paddingBottom: 4,
	},

	searchDates: {
		display: 'inline-flex',
		alignItems: 'flex-start',
	},

	searchIcon: {
		margin: '10px 0',
	},

	inputRoot: {
		color: 'inherit',
		width: '100%',
	},

	inputInput: {
		paddingTop: theme.spacing(1),
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		paddingLeft: theme.spacing(1),
		transition: theme.transitions.create('width'),
		width: '100%',
		borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
	},

	crossIcon: {
		cursor: 'pointer',
	},

});

export default styles;